"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import {A11y, Autoplay, Grid, Navigation, Pagination} from "swiper/modules";
import {Swiper, type SwiperProps, SwiperSlide} from "swiper/react";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import "./slider.scss";
import type {JSX} from "react";
import {useId} from "react";

interface Props extends SwiperProps {
	slides: JSX.Element[];
	navigationClass?: string;
}

export default function Slider({ slides, navigationClass, ...props }: Props) {
	const uniqueId = useId();
	const navClass =
		navigationClass || `swiper-nav-${uniqueId.replace(/:/g, "-")}`;

	return (
		<div className={navClass}>
			<Swiper
				modules={[Navigation, Pagination, A11y, Autoplay, Grid]}
				spaceBetween={20}
				slidesPerView={1}
				navigation={{
					nextEl: `.${navClass} .swiper-button-next`,
					prevEl: `.${navClass} .swiper-button-prev`,
				}}
				a11y={{
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
				}}
				{...props}
			>
				{slides.map((slide, index) => (
					// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
					<SwiperSlide key={index}>{slide}</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
